import React, { useState, useEffect, useLayoutEffect } from "react";
import { renderToString } from "react-dom/server";
import { Link } from "react-router-dom";
import DatePicker from "react-datepicker";
import DeleteRoundedIcon from "@mui/icons-material/DeleteRounded";
import VisibilityIcon from "@mui/icons-material/Visibility";
import ModeEditIcon from "@mui/icons-material/ModeEdit";
import { red } from "@mui/material/colors";
import {
  changeProductStatusController,
  productListController,
} from "../../services/productServices/productListingController";
import useFullPageLoader from "../../hooks/useFullPageLoader";
import useDebounce from "../../hooks/useDebounce";
import { toast } from "react-toastify";
import Pagination from "react-js-pagination";
import {
  dateFormatYear,
  showDateFormatYear,
  subtractAndFormatDate,
} from "../../utility/utils";
import ToggleStatus from "../../common/ToggleStatus";
import { Checkbox, FormControlLabel } from "@mui/material";
import ModalBox from "../../common/ModalBox";
import useButtonLoader from "../../hooks/useButtonLoader";
import TypingPlaceholder from "../../common/TypingPlaceholder";
import {
  activeRoleList,
  adminTypeListController,
  changeStatusSubAdminController,
  subAdminListController,
} from "../../services/subAdminServices/subAdminServices";

const SubAdminManagement = () => {
  const [addModal, setAddModal] = useState(false);
  const [subAdminList, setSubAdminList] = useState([]);
  const [subAdminId, setSubAdminId] = useState(null);
  const [statusModal, setStatusModal] = useState(false);
  const [search, setSearch] = useState("");
  const [filterByDate, setFilterByDate] = useState("");
  const [filterByStatus, setFilterByStatus] = useState();
  const [limit, setLimit] = useState(10);
  const [roleList, setRoleList] = useState([]);
  const [filterByRole, setFilterByRole] = useState("");
  const [startNumber, setStartNumber] = useState(1);
  const [totalList, setTotalList] = useState();
  const [activePage, setActivePage] = useState(1);
  const debounceValue = useDebounce(search, 500);
  const [loader, show, hide] = useFullPageLoader();
  const [submitButton, setSubmitButton] = useButtonLoader();

  const fetchingSubAdminList = async () => {
    try {
      show();
      // console.log(activePage);
      const response = await subAdminListController(
        activePage ? activePage : "",
        filterByStatus ? filterByStatus : "",
        limit ? limit : "",
        search ? search : "",
        filterByRole || ""
      );
      // console.log(response?.data?.data?.data, "Response---------->");
      if (response?.data?.code === 200) {
        hide();
        setTotalList(response?.data?.data?.count);
        setSubAdminList(response?.data?.data?.data);
      } else {
        toast.error(response?.message);
        hide();
      }
    } catch (e) {
      console.log(e.message);
      hide();
    }
  };

  const fetchRoleList = async () => {
    try {
      const response = await adminTypeListController(1, 1000);
      if (response?.data?.code === 200) {
        const roleData = response?.data?.data?.data;
        setRoleList(roleData);
      } else {
        toast.error(
          response?.response?.data?.message || response?.data?.message
        );
      }
    } catch (e) {
      console.log("Error fetching admin types:", e.message);
    }
  };

  // Sub-Admin Status Handler
  const handleSubAdminStatus = async () => {
    try {
      setSubmitButton(true);
      const response = await changeStatusSubAdminController(subAdminId);
      if (response?.data?.code === 200) {
        toast.success(response?.data?.message);
        setStatusModal(false);
        setSubmitButton(false);
        fetchingSubAdminList();
      } else {
        toast.error(response?.data?.message);
        setStatusModal(false);
        setSubmitButton(false);
      }
    } catch (e) {
      console.log(e.message);
      setSubmitButton(false);
    }
  };

  // Clear filter
  const clearFilter = () => {
    setActivePage(1);
    setLimit(10);
    setSearch("");
    setFilterByStatus("");
    setFilterByRole("")
    setFilterByDate("");
    fetchingSubAdminList();
  };

  //*Handle Pagination*
  const handlePageChange = (event) => {
    setActivePage(event);
  };

  useEffect(() => {
    fetchRoleList();
    fetchingSubAdminList();
  }, [filterByStatus, activePage, limit, debounceValue, filterByRole]);

  useEffect(() => {
    setStartNumber((activePage - 1) * limit + 1);
  }, [activePage]);

  return (
    <React.Fragment>
      <div className="main-panel">
        <div className="content-wrapper">
          <div className="page-header">
            <nav aria-label="breadcrumb"></nav>
          </div>
          <div className="page-header">
            <div className="page_title_wrap">
              <h2 className="page-title">Sub-Admin Management</h2>
              <div className="button_wrap">
                <Link
                  to="/sub-admin-management/role-management"
                  className="btn btn-outline-info cstm_btn_wrap_theme mx-2"
                  onClick={() => setAddModal(true)}
                >
                  <i className="mdi menu-icon menu-icon"></i>Manage Roles
                </Link>
                <Link
                  to="/sub-admin-management/add-member"
                  className="btn btn-outline-info cstm_btn_wrap_theme mx-2"
                  onClick={() => setAddModal(true)}
                >
                  <i className="mdi mdi-plus menu-icon menu-icon"></i>New Member
                </Link>
                <Link
                  to="#"
                  className="btn btn-outline-success cstm_btn_wrap_theme mx-2"
                  onClick={clearFilter}
                >
                  <i className="mdi mdi-refresh menu-icon menu-icon"></i> Reset
                </Link>
              </div>
            </div>
          </div>
          <div className="row wrap_selectCstm">
            <div className="col-1 cstm_padding_set">
              <select
                className="pageSelect input"
                onChange={(e) => setLimit(e.target.value)}
                value={limit}
              >
                <option value={"10"}>10</option>
                <option value={"25"}>25</option>
                <option value={"50"}>50</option>
                <option value={"100"}>100</option>
              </select>
            </div>
            <div className="col-lg-3 cstm_padding_set">
              <div className="search_box">
                <i className="mdi mdi-magnify"></i>
                <input
                  type="text"
                  className="form-control search cstm_btn_wrap_theme"
                  placeholder="Search by name,email address or Phone Number"
                  value={search}
                  onChange={(e) => {
                    setSearch(e.target.value);
                  }}
                />
              </div>
            </div>
            <div className="col-2 cstm_padding_set">
              <select
                className="btn btn-gradient-primary cstm_btn_wrap_theme2 wrap_select"
                onChange={(e) => setFilterByStatus(e.target.value)}
                value={filterByStatus}
              >
                <option value="">Status</option>
                <option value={0}>Inactive</option>
                <option value={1}>Active</option>
              </select>
            </div>
            <div className="col-lg-2 cstm_padding_set">
              <select
                className="btn btn-gradient-primary cstm_btn_wrap_theme2 wrap_select"
                onChange={(e) => setFilterByRole(e.target.value)}
                value={filterByRole}
              >
                <option value="">Roles</option>
                {roleList?.map((role) => (
                  <option key={role.id} value={role.role}>
                    {role.role}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <div className="row wrap_selectCstm">
            <div className="col-lg-3 cstm_padding_set"></div>
          </div>
          {loader}
          <div className="row wrap_selectCstm">
            <div className="col-lg-12 cstm_padding_set grid-margin stretch-card">
              <div className="card">
                <div className="card-body">
                  <div className="table-responsive">
                    <table className="table table-hover">
                      <thead>
                        <tr>
                          <th>S.No</th>
                          <th>Name</th>
                          <th>Email Id</th>
                          <th>Mobile Number</th>
                          <th>Role</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {subAdminList && subAdminList.length > 0 ? (
                          subAdminList.map(
                            (
                              { id, email, name, mobile, roleDetails, status },
                              index
                            ) => {
                              return (
                                <React.Fragment key={id}>
                                  <tr>
                                    <td>
                                      {(activePage - 1) * limit + ++index}
                                    </td>
                                    <td>{name || "---"}</td>
                                    <td>{email || "---"}</td>
                                    <td>{mobile || "---"}</td>
                                    <td>{roleDetails?.role || "---"}</td>
                                    <td>
                                      <div className="action_button_wrap">
                                        <div className="switch_button">
                                          <FormControlLabel
                                            control={
                                              <ToggleStatus
                                                onClick={() => {
                                                  setStatusModal(true);
                                                  setSubAdminId(id);
                                                }}
                                                sx={{ m: 1 }}
                                                checked={status == 1}
                                              />
                                            }
                                          />
                                        </div>
                                        <Link
                                          className="action_button"
                                          to={`/sub-admin-management/view/${id}`}
                                        >
                                          <VisibilityIcon
                                            className="cstm_eye"
                                            color="secondary"
                                          />
                                        </Link>
                                        <Link
                                          className="action_button"
                                          to={`/sub-admin-management/edit/${id}`}
                                        >
                                          <i className="mdi mdi-table-edit"></i>
                                        </Link>
                                      </div>
                                    </td>
                                  </tr>
                                </React.Fragment>
                              );
                            }
                          )
                        ) : (
                          <tr>
                            <td colSpan={6}>No Data Found</td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            <div className="d-flex justify-content-between align-items-center">
              <div>
                <h5>
                  Showing {startNumber} to{" "}
                  {startNumber + subAdminList?.length - 1} of {totalList}{" "}
                  entries
                </h5>
              </div>
              {totalList > 10 ? (
                <div className="pagination_wrap">
                  <Pagination
                    activePage={activePage}
                    linkClass="page-link"
                    previousLabel={"previous"}
                    nextLabel={"next"}
                    itemsCountPerPage={limit}
                    totalItemsCount={totalList}
                    pageRangeDisplayed={5}
                    itemClassLast="last_page next"
                    itemClassFirst="first_page prev"
                    activeLinkClass="active"
                    onChange={handlePageChange}
                  />
                </div>
              ) : null}
            </div>
          </div>
        </div>

        <ModalBox
          status={statusModal}
          onClose={() => {
            setStatusModal(false);
          }}
          title="Change Status"
          description="Are you sure you want to change the status of this subAdmin?"
          action={handleSubAdminStatus}
          uploadButtonElement={setSubmitButton}
        />
      </div>
    </React.Fragment>
  );
};

export default SubAdminManagement;
